import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioOption } from '@rx-applications/shared/utils';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonComponent),
      multi: true,
    },
  ],
})
export class RadioButtonComponent {
  /** JSON data object */
  @Input() public options: RadioOption[];

  /** Disable input */
  @Input() disabled?: boolean;

  /** Form name attribute */
  @Input() name: string;

  /** Unique identifier */
  @Input() id: number;

  /** Input required */
  @Input() requiredRadio = false;

  /** Set selected state */
  @Input() selected = false;

  /** device type */
  @Input() isMobile = false;

  /** radio buttons title */
  @Input() title?: string = null;

  @Input() secondaryTitle?: string = null;

  @Input() error?: string = null;

  /** On selection (event) */
  @Output() toggle = new EventEmitter<any[]>();

  /** If specific radio button was touched (interacted with) */
  isTouched = false;

  readonly tooltipPosition = ['top', 'auto'];

  /** Radio button selection */
  onToggle(obj) {
    this.isTouched = true;
    let selectedOption = obj;

    this.options.filter((res) => {
      if (res.id === obj.id) {
        res.isSelected = true;
        selectedOption = res;
      } else {
        if (res.isSelected) {
          delete res.isSelected;
        }
      }
    });
    this.toggle.emit(selectedOption);
  }


  public onChange = (value: any) => {/* Part of NG_VALUE_ACCESSOR implementation */ };

  public registerOnTouched = (fn: any) => {/* Part of NG_VALUE_ACCESSOR implementation */ };
  public writeValue = (value: any) => {
    this.onChange(value);
  };
  public registerOnChange = (fn: (val: any) => void) => (this.onChange = fn);

  /** Set disabled state */
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
